<template>
  <div tabindex="-1" class="modal-content">
    <div class="modal-body">
      <div v-if="options.success">
        <div class="px-4">
          <div
            class="d-flex flex-column align-items-center text-success"
            style="margin: 30px 0px"
          >
            <i style="font-size:80px" class="fa fa-check-circle mb-2"></i>
            <div style="font-size:20px" class="font-weight-bold">
              {{
                options.data.paymentType ? options.data.paymentType : "Payment"
              }}
              successful
            </div>
          </div>
          <div class="d-flex justify-content-between mb-1">
            <div>Patient</div>
            <div class="font-weight-bold">{{ options.data.patient }}</div>
          </div>
          <div class="d-flex justify-content-between mb-1">
            <div>Payment type</div>
            <div class="font-weight-bold">{{ options.data.method }}</div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="font-weight-bold">Amount paid</div>
            <div class="font-weight-bold">{{ options.data.amount }}</div>
          </div>
        </div>
        <div class="d-flex justify-content-center" style="margin: 30px 0px">
          <button @click="handleDismiss" type="button" class="btn btn-primary">
            {{ "Close" }}
          </button>
        </div>
      </div>
      <div v-else>
        <div class="px-4">
          <div
            class="d-flex flex-column align-items-center text-danger"
            style="margin: 30px 0px 15px 0px"
          >
            <i style="font-size:80px" class="fa fa-times-circle mb-2"></i>
            <div style="font-size:20px" class="font-weight-bold">
              Transaction error
            </div>
          </div>
          <div class="d-flex justify-content-center">
            {{ options.data?.message ?? "Something went wrong." }}
          </div>
        </div>
        <div class="d-flex justify-content-center" style="margin: 30px 0px">
          <button @click="handleDismiss" type="button" class="btn btn-primary">
            {{ "Close and try again" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // Include mixin

export default {
  name: "DialogPaymentResult",
  mixins: [DialogMixin],
  methods: {
    handleConfirm(option) {
      this.proceed(option); // included in DialogMixin
    },
    handleDismiss() {
      this.cancel(); // included in DialogMixin
    }
  },
  components: {}
};
</script>

<style scoped>
.modal-content {
  margin: -15px;
  width: auto;
}
</style>
